export default __webpack_public_path__ + "static/media/2.f7d9805f.jpg";